import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Clientes from './pages/Clientes';
import Equipos from './pages/Equipos';
import TiposEquipo from './pages/TiposEquipo';
import Solicitudes from './pages/Solicitudes';
import Informes from './pages/Informes';
import { authService } from './services/authService';

// Componente para rutas protegidas
function ProtectedRoute({ children }) {
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/clientes"
          element={
            <ProtectedRoute>
              <Clientes />
            </ProtectedRoute>
         } 
        />
        <Route 
          path="/equipos"
          element={
            <ProtectedRoute>
              <Equipos />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tipos-equipo"
          element={
            <ProtectedRoute>
              <TiposEquipo />
            </ProtectedRoute>
          } 
        />
        <Route 
            path="/solicitudes"
            element={
              <ProtectedRoute>
                <Solicitudes />
              </ProtectedRoute>
            } 
          />

        <Route 
            path="/informes"
            element={
              <ProtectedRoute>
                <Informes />
              </ProtectedRoute>
            } 
          />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;